import React, { Component } from 'react';
import './Header.css'
import PropTypes from 'prop-types';

class Header extends Component {

    constructor(props) {
        super(props);
        this.state = {
            packDrawerOpen: false,
            pendingPack: props.currentPack || props.selectedPack,
        };

        this.packControlsRef = React.createRef();
        this.handleOutsideClick = this.handleOutsideClick.bind(this);
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            prevProps.currentPack !== this.props.currentPack &&
            !this.state.packDrawerOpen
        ) {
            this.setState({
                pendingPack: this.props.currentPack || this.props.selectedPack,
            });
        }
        if (!prevState.packDrawerOpen && this.state.packDrawerOpen) {
            document.addEventListener("mousedown", this.handleOutsideClick);
        } else if (prevState.packDrawerOpen && !this.state.packDrawerOpen) {
            document.removeEventListener("mousedown", this.handleOutsideClick);
        }
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleOutsideClick);
    }

    handleOutsideClick(e) {
        if (
            this.state.packDrawerOpen &&
            this.packControlsRef.current &&
            !this.packControlsRef.current.contains(e.target)
        ) {
            this.setState({
                packDrawerOpen: false,
            });
        }
    }

    /** Renders the current score of the game */
    renderScore() {
        let leftScore = this.props.redRemainingGifs;
        let rightScore = this.props.blueRemainingGifs;
        let leftScoreColor = "red-text";
        let rightScoreColor = "blue-text";
        // If game is over, we overwrite the score board with the game outcome
        if (this.props.blueRemainingGifs === 0 || this.props.redRemainingGifs === -99) {
            // Blue wins, by finishing their cards or red clicks on bomb
            leftScore = "game over";
            rightScore = "blue won!";
            leftScoreColor = "gold-text";
            rightScoreColor = "blue-text";
        } else if (this.props.redRemainingGifs === 0 || this.props.blueRemainingGifs === -99) {
            // Red wins, by finishing their cards or blue clicks on bomb
            leftScore = "game over";
            rightScore = "red won!";
            leftScoreColor = "gold-text";
            rightScoreColor = "red-text";
        }
        return (
            <div className="score">
                <span className={"score-number " + leftScoreColor}>{leftScore}</span>
                 —
                <span className={"score-number " + rightScoreColor}>{rightScore}</span>
            </div>
        );
    }

    /** Renders the current turn in the game */
    renderTurn() {
        let className = "turn ";
        let textUnderliner = "text-underliner";
        if (this.props.gameEnded) {
            className += "grey-text";
            textUnderliner = "";
        } else if (this.props.isRedTurn) {
            className += "red-text";
        } else {
            className += "blue-text";
        }
        return (
            <div className={className} onClick={() => {this.props.endPlayerTurn()}}>
                <a className={textUnderliner}>end {this.props.isRedTurn ? "red" : "blue"}'s turn</a>
            </div>
        );
    }

    /** Renders the current player mode */
    renderPlayerMode() {
        return (
            <div className="player" onClick={() => {this.props.switchPlayerMode()}}>
                <a className="text-underliner">switch to {this.props.isPlayer ? "spymaster" : "player"}</a>
            </div>
        );
    }

    renderNewGame() {
        return (
            <div
                className="new-game"
                onClick={() => {
                    const packToUse =
                        this.state.pendingPack ||
                        this.props.currentPack ||
                        this.props.selectedPack;
                    if (this.props.newGame) {
                        this.props.newGame(packToUse);
                    }
                    this.setState({ packDrawerOpen: false });
                }}
            >
                <a className="text-underliner">new game</a>
            </div>
        );
    }

    renderPackDrawer() {
        const {
            packOptions = [],
            selectedPack,
            onPackChange,
            newGame,
            currentPack,
        } = this.props;
        const { packDrawerOpen, pendingPack } = this.state;

        const changePendingPack = value => {
            this.setState({ pendingPack: value });
            if (onPackChange) {
                onPackChange(value);
            }
        };

        return (
            <div className="pack-controls" ref={this.packControlsRef}>
                <div className="pack-newgame-row">
                    {this.renderNewGame()}
                    <div
                        className="settings-trigger"
                        onClick={() =>
                            this.setState({ packDrawerOpen: !packDrawerOpen })
                        }
                        aria-label="Choose GIF pack"
                        role="button"
                    >
                        ⚙︎
                    </div>
                </div>

                {packDrawerOpen && (
                    <div className="pack-drawer">
                        <div className="pack-drawer-title">
                            Choose a GIF pack
                        </div>
                        <div className="pack-list">
                            {packOptions.length ? (
                                packOptions.map(id => (
                                    <label className="pack-option" key={id}>
                                        <input
                                            type="radio"
                                            name="pack-choice"
                                            value={id}
                                            checked={pendingPack === id}
                                            onChange={e =>
                                                changePendingPack(
                                                    e.target.value
                                                )
                                            }
                                        />
                                        <span>Pack {id}</span>
                                        {currentPack === id && (
                                            <span className="pack-current-tag">
                                                current game
                                            </span>
                                        )}
                                    </label>
                                ))
                            ) : (
                                <div className="pack-loading">
                                    loading packs...
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>
        );
    }

    render() {
        return (
            <div className="header dark-header">
                <div className="header-space">
                    <div className="navbar">
                        {this.renderPlayerMode()}
                        {this.renderScore()}
                        {this.renderPackDrawer()}
                        {this.renderTurn()}
                    </div>
                </div>
            </div>
        )
    }

}

Header.propTypes = {
    redRemainingGifs: PropTypes.number,
    blueRemainingGifs: PropTypes.number,
    isRedTurn: PropTypes.bool,
    isPlayer: PropTypes.bool,
    switchPlayerMode: PropTypes.func,
    endPlayerTurn: PropTypes.func,
    gameEnded: PropTypes.bool,
    selectedPack: PropTypes.string,
    currentPack: PropTypes.string,
    packOptions: PropTypes.arrayOf(PropTypes.string),
    onPackChange: PropTypes.func,
    newGame: PropTypes.func,
};

export default Header;
